import React from 'react';
import XLSX from 'xlsx';

import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import EmptyList from '../../components/emptyList/EmptyList';
import LoadingPage from '../../components/loading/LoadingPage';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Button from '../../components/buttons/Button';
import PrintPdf from '../../utils/print/PrintPdf';
import SelectAjax from "../../components/form/SelectAjax";

const URL_LISTA = WS.relatorios.pagamentos;

//
class RelatoriosPagamentos extends React.Component{
  constructor (props){
    super(props);

    const date = new Date();
    let firstDay = 1 +'/'+  (date.getMonth()+1) +'/'+  date.getFullYear();
    let today = date.getDate() +'/'+  (date.getMonth()+1) +'/'+  date.getFullYear();

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      boleto: false,
      cartao: false,
      sexo: '',
      plano: '',
      dataInicial: firstDay,
      dataFinal: today,
      isLoading: false,
      data: [] /* Array of Arrays e.g. [["a","b"],[1,2]] */
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.printDiv = this.printDiv.bind(this);
    this.creatExcel = this.creatExcel.bind(this);
  }

  handleSelectChange (value) {
    this.setState({
      plano: value.value
    });
  }

  handleInputChange(event) {
   const target = event.target;
   const value = target.type === 'checkbox' ? target.checked : target.value;
   const name = target.name;

   this.setState({
     [name]: value
   });
 }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);
    /*const form = document.getElementById('form-data-adesao');

    let dti = null;
    let dtf = null;
    if(this.props.type === 'adesoes'){
      if(form){
        dti = form.querySelectorAll("[name='dti']")[0].value;
        dtf = form.querySelectorAll("[name='dtf']")[0].value;
      }
    }


    this.loadData({dti, dtf});*/
  }

  loadData(_args_) {
    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: _self.props.url,
      data:_args_,
      sucess:function(data){
        _self.setState({
          lista: data.items,
          isLoading: false,
          dataInicial: _args_.dti,
          dataFinal: _args_.dtf
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  handleSubmit(e){
    const form = document.getElementById('form-data-adesao');
    const dti = form.querySelectorAll("[name='dti']")[0].value;
    const dtf = form.querySelectorAll("[name='dtf']")[0].value;
    const boleto = this.state.boleto;
    const cartao = this.state.cartao;
    const plano = this.state.plano;
    const sexo = this.state.sexo;
    const data = {plano, sexo, dti, dtf, boleto, cartao};

    this.loadData(data);
    e.preventDefault();
  }

  getArrayExcel(){
    const arr = [];
    arr.push(["Nome", "E-mail", "Cpf", "Tipo de adesão"]);
    let lista = this.state.lista.map((value, i) => {
      arr.push([value.name,value.email,value.cpf_cnpj, (value.tipo_adesao === "B" ? "Boleto" : "Cartão")]);
    });
    return arr;
  }

  creatExcel(e){
    e.preventDefault();
    const arr = this.getArrayExcel();
    const ws = XLSX.utils.aoa_to_sheet(arr);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		XLSX.writeFile(wb, "foco90.xlsx");
  }

  printDiv(e){
    e.preventDefault();
    var sWinHTML = document.getElementById('printable').innerHTML;
    PrintPdf.print(sWinHTML);
    return false;
  }


  resultSearch(){
    let lista = this.state.lista.map((value, i) =>
      <div className='item-relatorio' key={i}>
          <div className='item-relatorio__title'>{value.name}</div>
          <div>E-mail: {value.email}</div>
          <div>Cpf: {value.cpf_cnpj}</div>
            {(() => {
              if(value.tipo_adesao){
                return <div>Pagamento: {value.tipo_adesao === 'B' ? 'Boleto' : 'Cartão'}</div>;
              }
            })()}

            {(() => {
              if(value.data_cadastro){
                const dataCadastro = value.data_cadastro.split('-').join('/');
                return <div>Data do cadastro: {dataCadastro}</div>;
              }
            })()}
            {(() => {
              if(value.parcelas){
                return <div>Nº de parcelas: {value.parcelas}</div>;
              }
            })()}
            {(() => {
              if(value.plano){
                return <div>Plano: {value.plano} ({value.valor})</div>;
              }
            })()}
            {(() => {
              if(value.data_pg && value.data_pg.length>5){
                const datapag = value.data_pg.split('-').join('/');
                return <div>Data do pagamento: {datapag}</div>;
              }
            })()}
            {(() => {
              if(value.tid){
                return <div>Tid: {value.tid}</div>;
              }
            })()}
      </div>
      );

    if(lista.length<=0){
      lista = <EmptyList />;
    }

    let result = (
      <div>
        <div className="box-bt-export">
          <div className="pure-u-g">
            <div className="pure-u-1-2">
              <div className="inner-bt-export"><a href='#' className='btpagseguro' onClick={this.printDiv}>Gerar pdf</a></div>
            </div>
            <div className="pure-u-1-2">
              <div className="inner-bt-export"><a href='#' className='btpagseguro' onClick={this.creatExcel}>Gerar excel</a></div>
            </div>
          </div>
          <br /><br />
        </div>
        <div id="printable">
          <div className='title-relatorio'>{this.state.lista.length} {this.props.title}</div>
          {lista}
        </div>
      </div>
    );

    return result;
  }

  render() {
    let lista = this.state.lista.map((value, i) =>
      <div className='item-relatorio' key={i}>
        <div className='item-relatorio__title'>{value.name}</div>
        <div className=''>Cpf: {value.cpf_cnpj}</div>
        <div className=''>E-mail: {value.email}</div>
        <div>Pagamento: {value.tipo_adesao === 'B' ? 'Boleto' : 'Cartão'}</div>
        {/*}<div>Cliente desde: 00/00/0000</div>
      <div>Pagamento: boleto (00/00/0000)</div>*/}
      </div>
      );

    if(lista.length<=0){
      lista = <EmptyList />
    }
    let wrapper = this.state.isLoading ? <LoadingPage /> : lista;

    const strings = this.state.strings;

    const { dataInicio, dataFim, procurar } = this.state.strings;
    const result = this.state.isLoading ? <LoadingPage /> : this.resultSearch();

    var date = new Date();
    var timestamp = date.getTime();


    return (
      <div>
        <div>
          <div className=''>
            <form onSubmit={this.handleSubmit} id="form-data-adesao" className='form-relatorio'>
              <div>
                <span className='title-relatorios'>Tipos de adesões</span>
              </div>

              <div className='box-relatorio-checks'>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="boleto" checked={this.state.boleto} onChange={this.handleInputChange} />
                    <span>{strings.adesoesBoleto}</span>
                  </div>
                </div>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="checkbox" name="cartao" checked={this.state.cartao} onChange={this.handleInputChange} />
                    <span>{strings.adesoesCartao}</span>
                  </div>
                </div>
              </div>
              <div>
                <span className='title-relatorios'>Sexo</span>
              </div>

              <div className='box-relatorio-checks'>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="radio" name="sexo" value="F" checked={(this.state.sexo === 'F')} onChange={this.handleInputChange} />
                    <span>{strings.feminino}</span>
                  </div>
                </div>
                <div className="pure-u-6-24">
                  <div className='checkItem'>
                    <input type="radio" name="sexo" value="M" checked={(this.state.sexo === 'M')} onChange={this.handleInputChange} />
                    <span>{strings.masculino}</span>
                  </div>
                </div>

              </div>

              <div>
                <span className='title-relatorios'>{strings.titlePlanos}</span>
              </div>

              <div className='box-relatorio-checks'>
                <div className="pure-u-12-24">
                  <SelectAjax  url={WS.planos.autocomplete} onChange={this.handleSelectChange}  title={strings.selecionePlano} />
                </div>
              </div>

              <div className="pure-u-9-24">
                <DateRangePickerWrapper
                  key={timestamp}
                    dti={this.state.dataInicial}
                    dtf={this.state.dataFinal}
                   titleDateInicio={dataInicio}
                   titleDateFim={dataFim} />
              </div>

              <div className="pure-u-9-24">
                <div className='box-button-search-date'><Button type="submit" text={procurar} classes="bt-save bt-blue" /></div>
              </div>
              <br /><br />
            </form>
          </div>
        </div>
        {result}
      </div>
    );
  }

}

export default RelatoriosPagamentos;



// WEBPACK FOOTER //
// ./src/classes/relatorios/RelatoriosPagamentos.js